import "./styles.css";
import BoxRow from "./ClassApp";

export default function App() {
  return (
    <div className="App">
      <BoxRow />
    </div>
  );
}
